<template>
  <main class="flex flex-col">
    <slot></slot>
  </main>
</template>
